module.exports = __webpack_public_path__ + "p7_img6.jpg?862708273b4e167dfa30024133b43568";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p7/p7_img6.jpg
// module id = 131
// module chunks = 0